import { MessageFilePayload } from "vue-advanced-chat";
import * as yup from "yup";
// import { generateDynamicSchema } from "./client.schema";

export const passwordSchema = () =>
	yup.object().shape({
		password: yup
			.string()
			.matches(
				/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
				"La contraseña debe contener como mínimo 8 caracteres y con un número"
			)
			.required("Ingrese la contraseña"),
		rpassword: yup
			.string()
			.oneOf([yup.ref("password"), null], "Las contraseñas no son iguales!")
			.required("Confirme la contraseña"),
	});
